
import CustomModal from '../../../../../components/Modal/CustomModal';
import {CustomTextField} from '../../../../../components/CustomTextField';
import CustomTimePicker from '../../../../../components/CustomTimePicker';
import AddEditMealApp from '../Functionality/AddEditMealApp';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../../components/buttons/IconButtons';
import React from "react";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AddEditMeal = (props) => {
    const { onHide, show, setModified, disabled = false } = props;
    const {
        t,
        emptyFields,
        item,
        isValidTime,
        handleChange,
        handleSubmit,
        handleClearFields,
        mealById,
        costInfo,
        isValidCost,
        isValidCostText,
        validateMealTimeCost
    } =AddEditMealApp({
        show,
        onHide,
        setModified
    });

    return (

        <CustomModal
            {...props}
            title={t(disabled ? 'service_time' : item?.id ? 'update_service_time' : 'create_service_time')}
            size='md'
            confirmButton={!disabled}
            onConfirm={() => {
                handleSubmit()
            }}
            classNameBody="pt-2"
        >
           <div className='row'>
               {!disabled && ( !mealById?.id || !mealById ) &&
                   <div className="col-12 d-flex justify-content-end mb-2 ">
                       <ButtonIcon
                           id='btn_aem_clean_fields'
                           Icon={CleanIcon}
                           onClick={handleClearFields}
                           title={'clear_instances'}
                           className={"btn-clean-secondary-600"}
                           tooltipPlacement={"right"}
                           iconProps='btn-icon-svg-12px icon-color-general-00'
                       />
                   </div>
               }

               <div className='col-12'>
                   <CustomTextField
                       id='txt_aem_name'
                       disabled={disabled}
                       name='name'
                       value={item.name}
                       trans='name'
                       emptyFields={emptyFields}
                       required={true}
                       onChange={handleChange}
                   />
               </div>
               <div className='col-6'>
                   <CustomTimePicker
                       id = 'tp_aem_start_time'
                       title={t('starts_at')}
                       name='startTime'
                       value={item.startTime}
                       handleChange={(value)=>{
                           handleChange({ target: { value: value, name: 'startTime' } });
                       }}
                       disabled={disabled}
                       formatInvalid={false}
                       emptyFields={emptyFields}
                       required={true}
                       ampm={false}
                   />
               </div>
               <div className='col-6'>
                   <CustomTimePicker
                       id = 'tp_aem_ends_at'
                       title={t('ends_at')}
                       name='endTime'
                       value={item.endTime}
                       handleChange={(value)=>{
                           handleChange({ target: { value: value, name: 'endTime' } });
                       }}
                       disabled={disabled}
                       formatInvalid={false}
                       emptyFields={emptyFields}
                       required={true}
                       ampm={false}
                       minTime={item.startTime}
                       isValid={isValidTime}
                       isValidText='time_invalid'
                   />
               </div>

               {costInfo?.isMealTimeCost &&
                   <div className='col-12'>
                       <CustomTextField
                           id='txt_aem_cost'
                           disabled={disabled}
                           name='cost'
                           trans="meal_cost"
                           type='text'
                           required={true}
                           onChange={(e) => {
                               handleChange(e);
                               validateMealTimeCost(e);
                           }}
                           suffixText={<p className={"ibl-font-w-600 text-uppercase"}>$</p>}
                           decimals={2}
                           showCounter={true}
                           length={8}
                           value={item.cost}
                           emptyFields={emptyFields}
                           isValid={isValidCost}
                           isValidText={isValidCostText}
                           helperText={"this_value_must_be_greater_than_0"}
                       />
                   </div>
               }
           </div>
        </CustomModal>
    );
};

export default AddEditMeal;
